import { Component, OnInit, ChangeDetectionStrategy, Input, SimpleChange, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormBuilder, FormControl } from '@angular/forms';
import { MaterialPageGrid } from '../../../../utils/material-page-grid';
import { AccountService } from '../../../../services/account.service';
import { HttpService } from '../../../../services/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

import * as moment from 'moment';

import { Subscription } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-cals-transactions',
  templateUrl: './cals-transactions.component.html',
  styleUrls: ['./cals-transactions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CalsTransactionsComponent implements OnInit, OnDestroy, AfterViewInit {
  customerId = null;
  accountType = 'INDIVIDUAL';
  @Input() accountList;
  @Input() stockCode;
  defualtPageGridSize = 10;

  // stockCode: string;
  duration = 'all';
  datePickerConfig: Partial<BsDatepickerConfig>;

  selAccount = new FormControl();

  // CALS
  calsTransactionPageGrid: MaterialPageGrid;
  calsTransactionGridInProgress: boolean;

  // calsClientDetails: any;
  calsCompanies: any;
  selectedCALSCompany: any;

  // Filters
  fromDate = moment(Date.now()).startOf('month').format('YYYY-MM-DD');
  toDate = moment(Date.now()).endOf('month').format('YYYY-MM-DD');
  accountListPerCategory: any;
  gridInProgress: boolean;
  downloadingReport;
  paramInvestorCode = null;
  investmentCodeTemp = null;
  unSubscribe: Subscription;
  displayedColumns: string[] = ['tradeDate', 'transactionType', 'stockCode', 'price', 'quantity', 'tradeValue'];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private httpService: HttpService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute
  ) {
    this.datePickerConfig = Object.assign(
      {},
      {
        containerClass: 'theme-dark-blue',
        dateInputFormat: 'YYYY-MM-DD',
        showWeekNumbers: false,
      }
    );
    this.unSubscribe = this.activatedRoute.parent.params.subscribe(async (params) => {
      if (this.calsTransactionPageGrid) {
        await this.initializeCALSGrid();
      }
      this.paramInvestorCode = params['investorCode'];
    });
  }
  async ngOnInit() {
    this.selAccount.valueChanges.subscribe(async (val) => {
      if (val) {
        this.customerId = val.customerId;
        console.log(val);
        this.accountService.setDetailView({ id: this.customerId, type: this.accountType, category: 0 });
        await this.initializeCALSGrid();
      }
    });
    try {
      this.calsCompanies = await this.accountService.getCALSCompanies(this.accountType, this.customerId, 'cals');
      this.calsCompanies.unshift({ code: 0, description: 'Click here to select a company' });
      await this.initializeCALSGrid();
    } catch (e) {}
    // if (this.selectedStockId) {
    //   alert(this.selectedStockId)
    // }
  }

  filterAccListPerPrd() {
    if (this.accountList && this.accountList.length > 0) {
      this.accountListPerCategory = this.accountList.filter((list) => list.category === 'OWN');
      if (this.accountListPerCategory && this.accountListPerCategory.length > 0) {
        this.selAccount.setValue(this.accountListPerCategory[0]);
        this.customerId = this.accountListPerCategory ? this.accountListPerCategory[0].customerId : null;
      }
    }
  }
  // Change Duration Periods of Transaction Grid
  changeTransactionDuration(duration) {
    this.duration = duration;
    if (duration === '1D') {
      this.toDate = moment(Date.now()).format('YYYY-MM-DD');
      this.fromDate = moment(Date.now()).format('YYYY-MM-DD');
    } else if (duration === '1W') {
      this.fromDate = moment(Date.now()).startOf('week').format('YYYY-MM-DD');
      this.toDate = moment(Date.now()).endOf('week').format('YYYY-MM-DD');
    } else if (duration === '1M') {
      this.fromDate = moment(Date.now()).startOf('month').format('YYYY-MM-DD');
      this.toDate = moment(Date.now()).format('YYYY-MM-DD');
    } else if (duration === '12M') {
      let year = moment(Date.now()).startOf('year').format('YYYY');
      let month = moment(Date.now()).format('M');
      if (Number(month) < 4) {
        year = moment(Date.now()).startOf('year').subtract(1, 'year').format('YYYY');
      }
      this.fromDate = moment(`${year}-04-01`).format('YYYY-MM-DD');
      this.toDate = moment(Date.now()).format('YYYY-MM-DD');
    } else {
      this.fromDate = this.toDate = '';
    }

    this.calsTransactionPageGrid.refreshData();
  }

  // Intialize CALS PageGrids
  async initializeCALSGrid() {
    // CALS Transaction Page Grid
    if (this.paramInvestorCode === this.investmentCodeTemp) {
      return;
    }
    this.investmentCodeTemp = this.paramInvestorCode;
    if (this.calsCompanies) {
      // this.calsClientDetails = await this.accountService.getFinanceClientDetails(this.accountType, this.customerId, 'CALS');
      this.calsCompanies = await this.accountService.getCALSCompanies(this.accountType, this.paramInvestorCode, 'cals');
      this.calsCompanies.unshift({ code: 0, description: 'Click here to select a company' });
    }

    this.calsTransactionPageGrid = new MaterialPageGrid(this.fb, this.defualtPageGridSize)
      .setTableColumns(this.displayedColumns)
      .setSource(async (listQuery) => {
        let count = 0;
        this.stockCode = listQuery.filterValues.stockCodeId;
        this.calsTransactionGridInProgress = true;
        if (this.duration === 'custom' && !listQuery.filterValues.dateFrom) {
          listQuery.filterValues.dateFrom = moment(Date.now()).subtract(1, 'months').toDate();
        }
        if (this.duration === 'custom' && !listQuery.filterValues.dateTo) {
          listQuery.filterValues.dateTo = moment(Date.now()).toDate();
        }
        if (this.duration === 'all') {
          this.fromDate = this.toDate = listQuery.filterValues.dateFrom = listQuery.filterValues.dateTo = '';
        }
        try {
          count = await this.accountService.getTransactionBalanceCount(
            this.accountType,
            this.paramInvestorCode,
            'cals',
            listQuery.filterValues.stockCodeId,
            this.fromDate ||
              (listQuery.filterValues.dateFrom && moment(listQuery.filterValues.dateFrom).startOf('day').format('YYYY-MM-DD')),
            this.toDate || (listQuery.filterValues.dateTo && moment(listQuery.filterValues.dateTo).startOf('day').format('YYYY-MM-DD'))
          );
        } catch (e) {
          this.calsTransactionGridInProgress = false;
        }

        let data = [];
        if (count > 0) {
          console.log('Fetching CALS Transaction', listQuery);
          try {
            this.calsTransactionGridInProgress = false;
            data = await this.accountService.getTransactionBalances(
              this.accountType,
              this.paramInvestorCode,
              'cals',
              listQuery.filterValues.stockCodeId,
              this.fromDate ||
                (listQuery.filterValues.dateFrom && moment(listQuery.filterValues.dateFrom).startOf('day').format('YYYY-MM-DD')),
              this.toDate || (listQuery.filterValues.dateTo && moment(listQuery.filterValues.dateTo).startOf('day').format('YYYY-MM-DD')),
              listQuery.pageIndex,
              listQuery.pageSize,
              listQuery.sortField
            );
            this.calsTransactionGridInProgress = false;
          } catch (e) {
            this.calsTransactionGridInProgress = false;
          }
        } else {
          this.calsTransactionGridInProgress = false;
        }
        console.log('CALS Transaction Data:', { data, total: count, displayedColumns: this.displayedColumns });

        return { data, total: count };
      })
      .setFilters({
        stockCodeId: [this.stockCode || this.calsCompanies[0].code],
        dateFrom: [moment().subtract(1, 'months').toDate()],
        dateTo: [moment().toDate()],
      });
    setTimeout(() => this.changeTransactionDuration(this.duration), 100);

    console.log(this.calsTransactionPageGrid);

    setTimeout(() => {
      if (this.paginator) {
        console.log('Attaching paginator');
        this.calsTransactionPageGrid.attachPaginator(this.paginator);
      } else {
        console.warn('Paginator not available at this time');
      }
      if (this.calsTransactionPageGrid && this.sort) {
        this.calsTransactionPageGrid.attachSort(this.sort);
      }
    }, 1500);
  }

  async downloadReport() {
    this.downloadingReport = true;
    let downloadURL = `/account/me/financial/transaction/cals/export?accountType=INDIVIDUAL&fromDate=${this.fromDate}&toDate=${
      this.toDate
    }${this.stockCode ? '&stockCode=' + this.stockCode : ''}`;

    let data = await this.get(downloadURL);
    try {
      this.downloadFile(data, 'Transaction Summary - ' + moment(new Date()).format('YYYY-MM-DD') + '.pdf');
      this.downloadingReport = false;
    } catch (e) {
      this.downloadingReport = false;
    }
  }
  get(url: string, data?: any) {
    const token = localStorage['atk'];
    let formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;
    let headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);

    return this.http.get(formattedUrl, { headers, responseType: 'blob' }).toPromise();
  }

  downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 1);
  };
  ngAfterViewInit() {
    // setTimeout(() => {
    //   if (this.calsTransactionPageGrid && this.sort) {
    //     this.calsTransactionPageGrid.attachSort(this.sort);
    //   }
    //   if (this.calsTransactionPageGrid && this.paginator) {
    //     this.calsTransactionPageGrid.attachPaginator(this.paginator);
    //   }
    // }, 1500);
  }
  ngOnDestroy() {
    this.unSubscribe.unsubscribe();
  }
}
